<template>
    <div class="gray-text-box">
        <span>{{text}}</span>
    </div>
</template>

<script>
export default {
    name: 'BgGrayText',
    props: ["text"],
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/bgGrayText.scss';
</style>